<template>
  <div class="q-pa-md" >
    <q-input outlined v-model="value"
              mask="##/####"
              @input="onInputChange"
              :label="label"
             :rules="[monthYeartimeValidation]"
              >
      <template v-slot:append>
        <q-icon name="event" class="cursor-pointer">
          <q-popup-proxy
            ref="qDateProxy"
            transition-show="scale"
            transition-hide="scale"
          >
            <q-date
              v-model="value"
              :rules="rules"
              default-view="Years"
              years-in-month-view
              emit-immediately
              mask="MM/YYYY"
              @input="onInput"
              :min="new Date()"
              :navigation-max-year-month="eventMaxYearMonth"
              :navigation-min-year-month="eventMinYearMonth"
             >
              <div class="row items-center justify-end">
                <q-btn v-close-popup label="Close" color="primary" flat></q-btn>
              </div>
            </q-date>
          </q-popup-proxy>
        </q-icon>
      </template>
    </q-input>
  </div>
</template>

<script>
import { type } from 'os'
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'ServiceRequestInvoiceSettlementDate',
  components: {},
  props: {
    value: {
      required: true
    },
    navigationMaxYearMonth: {
      type: String
    },
    navigatorMinYearMonth: {
      type: String
    },
    label: {
      type: String
    },
    rules: {
      type: Array,
      required: false
    }
  }
})
class ServiceRequestInvoiceSettlement extends Vue {
  selected = { year: false, month: false };

  get eventMaxYearMonth () {
    return this.validateDate(this.navigationMaxYearMonth)
  }

  get eventMinYearMonth () {
    return this.validateDate(this.navigatorMinYearMonth)
  }

  onInputChange (value) {
    if (this.isValidMask(value)) {
      this.__set(value, true)
    } else {
      this.__set(null, false)
    }
  }

  isValidMask (value) {
    if (value && value.length === 7) return true
    return false
  }

  validateDate (value) {
    if (!value || value.length !== 7) {
      return ''
    } else {
      const numbers = value.split('/')
      return numbers[1] + '-' + numbers[0] + '-01'
    }
  }

  onInput (value, reason, details) {
    reason === 'year' ? (this.selected.year = true) : null
    reason === 'month' ? (this.selected.month = true) : null

    if (this.selected.year && this.selected.month) {
      this.$refs.qDateProxy.hide()
      this.selected = { year: false, month: false }
    }
    this.__set(value, true)
  }

  __set (e, forceUpdate) {
    const val = e && e.target ? e.target.value : e
    this.$emit('input', val)
    if (forceUpdate) {
      this.$nextTick(() => {
        if (JSON.stringify(val) !== JSON.stringify(this.value)) {
          this.$emit('change', val)
        }
      })
    }
  }

  monthYeartimeValidation (val) {
    if (!val) return val
    const expr = /^(0[1-9]|1[0-2])\/\d{4}$/
    return val.match(expr) || this.$gettext('INVALID_DATE_MESSAGE')
  }
}

export default ServiceRequestInvoiceSettlement
</script>

<style lang="stylus" scoped></style>
